import React from 'react';
import EntitySummary from "./summary/EntitySummary";
import {dataSummary} from "../../../mock/dataMock";

function Dashboard() {
  return (
      <>
        <EntitySummary data={dataSummary.entities}/>
      </>
  );
}

export default Dashboard;
